import $ from 'jquery';

const postInsight = element => {
    const $more = element.find('.post-insight__more');
    const $less = element.find('.post-insight__less, .post-insight__close');

    if ($more.length && $less.length) {
        const $hidden = element.find('.post-card').filter(function () {
            return $(this).is(':hidden');
        });

        $more.off('click');
        $less.off('click');

        $more.on('click', () => {
            $hidden.show(300);
            $less.show();
            $more.hide();
        });

        $less.on('click', () => {
            $hidden.hide(300);
            $less.hide();
            $more.show();
        });
    }
};

export const reloadScriptPostInsight = () => {
    const $element = $('.post-insight');

    $element.each(function () {
        postInsight($(this));
    });
};
reloadScriptPostInsight();
